import Vue from "vue";
import axios from "axios";
import { set } from "lodash";
const baseUrl = '/wp-json/wp/v2'
Vue.prototype.$eventHub = new Vue();


document
  .querySelectorAll('.vue-formations')
  .forEach((el) => {
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const formations = await $http.$get(`${baseUrl}/formations`);
      return { formations };
    },
    el,
    data() {
      return {
        searchQuery: '',
        filters: {
          page: 1,
          per_page: 9,
          formation_type: '',
          formation_category: '',
        },
        formations: [],
        types: [],
        categories: [],
        current_formation_id: null,
        formation_type: [],
        totalPages: null,
      };
    },    
    created() {
      this.getFormations();
    },
    mounted(){
      this.getTypes();
      this.getCategories();
    },
    computed: {      
      // orderPartnerType() {
      //   return this.formation_type.sort((a, b) => a.id - b.id);
      // },
      hasMore() {
        return this.totalPages > this.formations.length;
      },
    },
    methods: {  
      // classClickable(partner){
      //   return {
      //     'cursor-pointer' : partner.content.rendered,
      //     'pointer-events-none' : !partner.content.rendered,
      //   }
      // },  
      openModal (formation) {
        // if(!partner.content.rendered) {          
        //   return
        // }
        console.log('formation', formation)
        this.current_formation_id = formation.id
        setTimeout(() => {
          this.$eventHub.$emit('modal:formation:open', formation.id)
        }, 300)
      },
      resetFilters() {
        this.filters = {
          page: 1,
          per_page: this.filters.per_page,
          formation_type: '',
          formation_category: '',
        }
        this.getFormations()
      },
      getFormations(more = false) {
        let filtersAPI = Object.assign({}, this.filters);
        if (filtersAPI.formation_type === "") {
          delete filtersAPI.formation_type;
        }
        if (filtersAPI.formation_category === "") {
          delete filtersAPI.formation_category;
        }
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/formations`,
            params: filtersAPI,
            headers: { 'content-type': 'application/json' },
          })
          .then((response) => {
            this.formations = (more)? this.formations.concat(response.data) : response.data
            this.totalPages = response.headers["x-wp-total"];
          })
          .catch((error) => {
            this.errors = Object.assign(this.errors, error.response.data);
          });
      },      
      getTypes() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/formation_type`,
            params: {},
          })
          .then((response) => {
            this.types = response.data
          });
      },
      getCategories() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/formation_category`,
            params: {
              per_page: 50,
            }
          })
          .then(response => {
            this.categories = response.data
          })
      },
      // deleteEmptyCategories(cat) {
      //   return cat.filter((el) => el.count != 0)
      // },
      getMoreFormations() {
        this.filters.page++;
        this.getFormations(true);
      },    
      // updateSearch(e){
      //   this.filters.search = this.searchQuery
      //   this.getPartners();
      // },
      updateFilters (event) {
        if (event.target.value) {
          this.filters.page = 1
          this.filters.formation_type = event.target.value;
          // delete this.filters.search;
          // this.searchQuery = null
        } else {
          delete this.filters.formation_type;
        }
        this.getFormations();
      },
      updateCategory (event) {
        if (event.target.value) {
          this.filters.page = 1
          this.filters.formation_category = event.target.value;
          // delete this.filters.search;
          // this.searchQuery = null
        } else {
          delete this.filters.formation_category;
        }
        this.getFormations();
      }
      // updateType(type) {
      //   if (type) {
      //     this.filters.page = 1
      //     this.filters.formation_type = type;
      //     delete this.filters.search;
      //     this.searchQuery = null
      //   } else {
      //     delete this.filters.formation_type;
      //   }
      //   this.getPartners();
      // }
    },
  });
})
